<app-popover-secondary (closeCallback)="cancelCallback()" [customStyle]="'multiple-cab-track'">
  <div class="multi-track-container" popover-content>
    <div class="track-header">
      <div class="track-title">
        Fix Geocode
      </div>
    </div>
    <div class="grocode-container">

      <div class="left-column">
        <div *ngIf="filterDetails">

          <div class="">
            <div class="search-wrapper">
              <img src="assets/images/search-icon.svg" class="input-icon suffix" />
              <input class="has-suffix" style="border: 0;" placeholder="Search"
                [formControl]="filterDetails.get('search')" (keyup)="onSearchChange()" />
            </div>
          </div>

          <div class="select-container">

            <div class="form-control">
              <label class="form-label mr-10">City</label>
              <div class="input-wrapper">
                <app-select (changeCallback)="filterBookings()" type="dropdown"
                  [formControl]="filterDetails.get('city')" [blockInitialChangeCallback]="true" [options]="cityList">
                </app-select>
              </div>
            </div>
            <div class="form-control">
              <label class="form-label mr-10">Status</label>
              <div class="input-wrapper">
                <app-select (changeCallback)="filterBookings()" type="dropdown"
                  [formControl]="filterDetails.get('status')" [blockInitialChangeCallback]="true"
                  [options]="statusList">
                </app-select>
              </div>
            </div>
          </div>
        </div>

        <div class="table-container">

          <table *ngIf="track">
            <thead class="cab-track-header">
              <th class="checkbox-col">
                <app-checkbox (checkboxSelectedCallback)="toggleMasterCheckbox()" [checked]="checkedBookingCount"
                  [type]="checkedBookingCount < filteredBookingIds.length ? 'hyphen' : 'checkmark'">
                </app-checkbox>
              </th>
              <th>#</th>
              <th class="booking-id-col">Booking ID</th>
              <th class="cab-id-col">Cab ID</th>
              <th class="cab-reg-col">Registration No</th>
              <th class="status-col">Status</th>


            </thead>
            <tr *ngFor="let bookingId of filteredBookingIds; let bIndex = index"
              [ngClass]="{'disabled-row': !track[bookingId].isTrackable}">
              <td class="checkbox-col">
                <app-checkbox (checkboxSelectedCallback)="bookingCheckboxClick(bookingId)"
                  [checked]="track[bookingId].checked && track[bookingId].isTrackable"></app-checkbox>
              </td>
              <td lass="counter">
                <li type="number"></li>
              </td>
              <td class="booking-id-col">
                <span class="unique-index" (click)="focusMapOnBooking(bookingId)">{{track[bookingId].uniqueNo}}</span>
                <span class="booking-id ellipsis" (click)="focusMapOnBooking(bookingId)"
                  [title]="bookingId">{{bookingId}}</span>
              </td>
              <td lass="cab-id-col">{{track[bookingId].track && track[bookingId].track.cab &&
                track[bookingId].track.cab.cabId}}</td>
              <td class="cab-reg-col">{{track[bookingId].track && track[bookingId].track.cab &&
                track[bookingId].track.cab.identification}}</td>
              <td class="status-col">
                <span
                  [ngClass]="{'status-chip': track[bookingId].currentStatus, 'delayed': track[bookingId].currentStatus == 'delayed'}">
                  {{track[bookingId].currentStatus || '--'}}
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="right-column">
        <div id="stop-location-map"></div>
        <app-map-controls *ngIf="map" [trafficControl]="false" [map]="map"></app-map-controls>
      </div>

    </div>
  </div>
</app-popover-secondary>